import { autobind } from 'core-decorators';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

export interface SoundComponentProps {
    audioRef?: (ref: HTMLAudioElement, play) => void;
    url: string;
    autoplay?: boolean;
    hotKeyListener?;
}

@observer export class SoundComponent extends Component<SoundComponentProps, any> {

    audioRef: HTMLAudioElement;
    svgRef: SVGSVGElement;
    svgCircleRef: SVGPathElement;
    totalLength;

    @observable isPlaying = false;

    componentDidMount(): void {
        this.totalLength = this.svgCircleRef.getTotalLength();

        this.svgCircleRef.setAttribute('stroke-dasharray', this.totalLength + '');
        this.svgCircleRef.setAttribute('stroke-dashoffset', this.totalLength + '');

        if (this.props.audioRef) {
            this.props.audioRef(this.audioRef, () => {
                this.audioRef?.play();
                this.isPlaying = true;
            });
        }

        if (this.audioRef) {
            this.audioRef.ontimeupdate = this._onTimeUpdate;
            this.audioRef.onended = this._onEnd;
            this.audioRef.oncanplay = () => {
                if (this.props.autoplay) {
                    this.audioRef?.play();
                    this.isPlaying = true;
                }
            };
        }

        document.addEventListener ("keydown", this.hotKeyListener);
    }

    @autobind hotKeyListener(event) {
        if (this.props.hotKeyListener) {
            this.props.hotKeyListener(event, this.play);
        }
    }

    @action.bound play() {
        if (this.audioRef.paused) {
            this.audioRef.currentTime = 0;
            this.isPlaying = true;
            const promise = this.audioRef?.play();

            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                }).catch(error => {
                    this.isPlaying = false;
                });
            }
        } else if (this.audioRef) {
            this.audioRef.pause();
            // this.audioSuccess.currentTime = 0;
            this.isPlaying = false;
        }
    }

    @autobind _onTimeUpdate() {
        if (this.audioRef) {
            const currentTime = this.audioRef.currentTime;
            const maxduration = this.audioRef.duration;
            const calc = this.totalLength - (currentTime / maxduration * this.totalLength);

            this.svgCircleRef.setAttribute('stroke-dashoffset', calc + '');
        }
    }

    @autobind _onEnd() {
        this.isPlaying = false;
        this.svgCircleRef.setAttribute('stroke-dashoffset', this.totalLength + '');
    }

    _renderPlay() {
        return <>
            <button className="play" onClick={this.play} />
            <svg viewBox="0 0 100 100" ref={elm => this.svgRef = elm}>
                <path id="circle" ref={elm => this.svgCircleRef = elm} fill="none" stroke={'#e74543'} strokeMiterlimit="10" d="M50,2.9L50,2.9C76,2.9,97.1,24,97.1,50v0C97.1,76,76,97.1,50,97.1h0C24,97.1,2.9,76,2.9,50v0C2.9,24,24,2.9,50,2.9z"/>
            </svg>
        </>
    }

    render() {
        const { url, autoplay } = this.props;
        const trackClass = this.isPlaying ? 'playing' : '';

        return <div className={'audio-wrapper'}>
            <audio ref={elm => this.audioRef = elm} autoPlay={false} controls>
                <source src={url} />
            </audio>

            <div className={`track ${trackClass}`}>
                { this._renderPlay() }
            </div>
        </div>
    }

    private removeHotKeyListener() {
        document.removeEventListener('keydown', this.hotKeyListener);
    }

}
